import constants from '../../Constants';

const questionAssets = {

    /**
     * Return an array of extra assets in the question to tell the pre renderer how the question should be handled
     * @param itemBodyString
     * @param responseModels
     * @returns {Array}
     */
    getExtraAssets(itemBodyString, responseModels) {
        const assets = [];
        const { interactionType } = constants;

        if (itemBodyString.indexOf('math-tex') !== -1) {
            assets.push('mathjax');
        }
        if (!responseModels) {
            return assets;
        }
        for (const responseModel of responseModels) {
            if (responseModel.type === interactionType.EXTENDED_TEXT_INTERACTION) {
                if (!responseModel.usePlainText && responseModel.variant === '') {
                    assets.push('ckeditor');
                } else if (!responseModel.usePlainText && responseModel.variant === 'math') {
                    assets.push('mathquill');
                } else if (responseModel.variant === 'code' || responseModel.variant === 'code-compiler') {
                    assets.push('aceEditor');
                }
            }
            if (responseModel.type === interactionType.TEXT_ENTRY_INTERACTION && responseModel.interactionType === 'math') {
                assets.push('mathquill');
            }

            // questions with objects are graphical questions like drag and drop / hotspot / matching
            if (Array.isArray(responseModel.objects) && responseModel.objects.length > 0) {
                assets.push('images');
            }
        }

        return assets;
    },
};

export default questionAssets;
